import * as types from 'models/actionTypes'
import * as msgTypes from 'models/iFrame/msgTypes'
import { navigateBack, setResumeParam } from 'models/iFrame/actions'
import { getIsIFrame } from 'models/location/selectors'

const messageParent = (action) => {
    try {
        if (getIsIFrame()) {
            window.parent.postMessage(action, '*')
        }
    } catch (e) {
        // eslint-disable-block
    }
}

const iFrameMiddleware = () => (next) => (action) => {
    const returnState = next(action)
    switch (action.type) {
        case types.NEW_IFRAME_MESSAGE: {
            const { message } = action
            messageParent(message)
            break
        }
        case types.REQUEST_IKEA_TOKENS: {
            messageParent({ type: msgTypes.GET_TOKENS })
            break
        }
        case types.SET_MAGIC_WINDOW_LOADING: {
            if (!action.isMagicWindowLoading) {
                messageParent({ type: msgTypes.MAGIC_WINDOW_LOADED })
            }
            break
        }
        case types.DELETE_COMPOSITION_RENDER_ITEM: {
            if (action.trackingInfo) {
                messageParent({
                    type: msgTypes.MAGIC_WINDOW_GA_TRACKING,
                    action: 'remove_product',
                    label: action.trackingInfo.LocalItemNumber,
                })
            }
            break
        }
        case types.PLACE_RENDER_ITEM: {
            if (action.trackingInfo) {
                messageParent({
                    type: msgTypes.MAGIC_WINDOW_GA_TRACKING,
                    action: 'add_product',
                    label: action.trackingInfo.LocalItemNumber,
                })
            }
            break
        }
        case types.UPDATE_COMPOSITION_RENDER_ITEM: {
            if (action.trackingInfo) {
                messageParent({
                    type: msgTypes.MAGIC_WINDOW_GA_TRACKING,
                    action: 'move_product',
                    label: action.trackingInfo.LocalItemNumber,
                })
            }
            break
        }
        case types.RECEIVE_SAVE_COMPOSITION: {
            const { compositionId, originId } = action
            messageParent({
                type: msgTypes.MAGIC_WINDOW_GA_TRACKING,
                action: 'save',
                label: `${originId}|${compositionId}`,
            })
            break
        }
        case types.ADD_TO_BAG: {
            const { trackingInfo, localItemNumber } = action
            if (trackingInfo && localItemNumber) {
                messageParent({
                    type: msgTypes.MAGIC_WINDOW_GA_TRACKING,
                    action: 'add_to_bag',
                    label: localItemNumber,
                })
            }
            break
        }
        case types.TRACK_SHOW_DETAILS: {
            const { trackingInfo } = action
            // Only track when there is a productId/title/accessFrom fields
            if (trackingInfo && trackingInfo.LocalItemNumber) {
                messageParent({
                    type: msgTypes.MAGIC_WINDOW_GA_TRACKING,
                    action: 'get_additional_details',
                    label: trackingInfo.LocalItemNumber,
                })
            }
            break
        }
        case types.TOGGLE_FAVORITE: {
            const { isFavorite, localItemNumber } = action
            const gaAction = isFavorite ? 'add_favorite' : 'remove_favorite'
            if (localItemNumber) {
                messageParent({
                    type: msgTypes.MAGIC_WINDOW_GA_TRACKING,
                    action: gaAction,
                    label: localItemNumber,
                })
            }
            break
        }
        case types.OPEN_DESIGN_LAB: {
            messageParent(navigateBack())
            // window.open(getDesignLabUrl(), '_top') // Legacy behavior
            break
        }
        case types.REQUEST_LOGIN_PAGE: {
            messageParent(setResumeParam())
            break
        }
        default:
            break
    }
    return returnState
}

export default iFrameMiddleware
